"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
var _link = _interopRequireDefault(require("./link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var transformRichText = function transformRichText(doc) {
  return doc ? (0, _processRichText["default"])({
    document: doc,
    factories: _standard["default"]
  }) : null;
};
var availabilityCheckerResultsFactory = function availabilityCheckerResultsFactory(_ref) {
  var _sys$contentType, _getProp, _getProp2, _getProp3, _getProp4, _getProp5, _getProp6, _getProp7;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    loadingDoc: transformRichText((0, _utils.getProp)(fields, 'loading')),
    errorDoc: transformRichText((0, _utils.getProp)(fields, 'error')),
    searchSummary: (0, _utils.getProp)(fields, 'searchSummary'),
    happyPathHeading: (0, _utils.getProp)(fields, 'happyPathHeading'),
    happyPathIntro: (0, _utils.getProp)(fields, 'happyPathIntro'),
    happyPathAlternativesHeading: (0, _utils.getProp)(fields, 'happyPathAlternativesHeading'),
    mixedResultsAlternativesHeading: (0, _utils.getProp)(fields, 'mixedResultsAlternativesHeading'),
    mixedResultsAlternativesIntroDoc: transformRichText((0, _utils.getProp)(fields, 'mixedResultsAlternativesIntro')),
    stiTestingTitle: (0, _utils.getProp)(fields, 'stiTestingTitle'),
    stiTestingButtons: ((_getProp = (0, _utils.getProp)(fields, 'stiTestingButtons')) === null || _getProp === void 0 ? void 0 : _getProp.map(function (link) {
      return (0, _link["default"])(link);
    })) || null,
    emergencyContraceptionTitle: (0, _utils.getProp)(fields, 'emergencyContraceptionTitle'),
    emergencyContraceptionButtons: ((_getProp2 = (0, _utils.getProp)(fields, 'emergencyContraceptionButtons')) === null || _getProp2 === void 0 ? void 0 : _getProp2.map(function (link) {
      return (0, _link["default"])(link);
    })) || null,
    contraceptionTitle: (0, _utils.getProp)(fields, 'contraceptionTitle'),
    combinedPillButton: fields !== null && fields !== void 0 && fields.combinedPillButton ? (0, _link["default"])((0, _utils.getProp)(fields, 'combinedPillButton')) : null,
    progestogenOnlyPillButton: fields !== null && fields !== void 0 && fields.progestogenOnlyPillButton ? (0, _link["default"])((0, _utils.getProp)(fields, 'progestogenOnlyPillButton')) : null,
    pillComparisonLink: fields !== null && fields !== void 0 && fields.pillComparisonLink ? (0, _link["default"])((0, _utils.getProp)(fields, 'pillComparisonLink')) : null,
    contraceptivePatchButton: fields !== null && fields !== void 0 && fields.contraceptivePatchButton ? (0, _link["default"])((0, _utils.getProp)(fields, 'contraceptivePatchButton')) : null,
    contraceptiveRingButton: fields !== null && fields !== void 0 && fields.contraceptiveRingButton ? (0, _link["default"])((0, _utils.getProp)(fields, 'contraceptiveRingButton')) : null,
    contraceptiveInjectionButton: fields !== null && fields !== void 0 && fields.contraceptiveInjectionButton ? (0, _link["default"])((0, _utils.getProp)(fields, 'contraceptiveInjectionButton')) : null,
    genitalDiagnosisTitle: (0, _utils.getProp)(fields, 'genitalDiagnosisTitle'),
    genitalDiagnosisButtons: ((_getProp3 = (0, _utils.getProp)(fields, 'genitalDiagnosisButtons')) === null || _getProp3 === void 0 ? void 0 : _getProp3.map(function (link) {
      return (0, _link["default"])(link);
    })) || null,
    prepTitle: (0, _utils.getProp)(fields, 'prepTitle'),
    prepButtons: ((_getProp4 = (0, _utils.getProp)(fields, 'prepButtons')) === null || _getProp4 === void 0 ? void 0 : _getProp4.map(function (link) {
      return (0, _link["default"])(link);
    })) || null,
    kickoutHeading: (0, _utils.getProp)(fields, 'kickoutHeading'),
    kickoutIntroDoc: transformRichText((0, _utils.getProp)(fields, 'kickoutIntro')),
    kickoutAlternativesHeading: (0, _utils.getProp)(fields, 'kickoutAlternativesHeading'),
    hcrgHeading: (0, _utils.getProp)(fields, 'hcrgHeading'),
    hcrgIntroDoc: transformRichText((0, _utils.getProp)(fields, 'hcrgIntro')),
    hcrgButtons: ((_getProp5 = (0, _utils.getProp)(fields, 'hcrgButtons')) === null || _getProp5 === void 0 ? void 0 : _getProp5.map(function (link) {
      return (0, _link["default"])(link);
    })) || null,
    fettleIntroDoc: transformRichText((0, _utils.getProp)(fields, 'fettleIntro')),
    fettleButtons: ((_getProp6 = (0, _utils.getProp)(fields, 'fettleButtons')) === null || _getProp6 === void 0 ? void 0 : _getProp6.map(function (link) {
      return (0, _link["default"])(link);
    })) || null,
    localClinicHeading: (0, _utils.getProp)(fields, 'localClinicHeading'),
    localClinicIntroDoc: transformRichText((0, _utils.getProp)(fields, 'localClinicIntro')),
    localClinicButtons: ((_getProp7 = (0, _utils.getProp)(fields, 'localClinicButtons')) === null || _getProp7 === void 0 ? void 0 : _getProp7.map(function (link) {
      return (0, _link["default"])(link);
    })) || null
  };
};
var _default = availabilityCheckerResultsFactory;
exports["default"] = _default;